module.exports = __webpack_public_path__ + "media/images/home-trimmy-7c46f41a.png";